module.exports = __webpack_public_path__ + "static/media/B0.8426500d.svg";